import { dreamteamProxy, getHeaders } from './proxies';

export default class DreamteamService {
  getGames(): Promise<Object> {
    return dreamteamProxy.get(
      `/games?gameType=${process.env.REACT_APP_GAME_TYPE || 'fives'}&pageSize=500`, // TODO: Change this to use pagination properly
      {
        headers: {
          'X-IG-SiteId': process.env.REACT_APP_SITE_ID || ''
        }
      }
    );
  }

  getEntries(token: string, gameId: number): Promise<Object> {
    let url = `/entries`;
    if (gameId) {
      url = url + `?gameId=${gameId}`;
    }
    return dreamteamProxy.get(url, {
      headers: getHeaders(token)
    });
  }

  getBonuses(token: string): Promise<Object> {
    // TODO: Implement the API call here.
    return new Promise((resolve) => resolve({}));
  }

  postEntry(token: string, gameId: number, uniqueId: string, promotion?: string): Promise<Object> {
    return dreamteamProxy.post(
      `/entry`,
      {
        gameId,
        uniqueId,
        promotion
      },
      {
        headers: getHeaders(token)
      }
    );
  }

  putTeamMember(token: string, receipt: string, selectionNumber: number): Promise<Object> {
    const url = `/entry/${receipt}/reveal/${selectionNumber}`;
    return dreamteamProxy.put(
      url,
      {},
      {
        headers: getHeaders(token)
      }
    );
  }

  getPrize(token: string, receipt: string): Promise<Object> {
    let url = `/entry/${receipt}/prize`;

    return dreamteamProxy.get(url, {
      headers: getHeaders(token)
    });
  }
}
